import { createZodDto } from './zod';

import { z } from 'zod';

//CREATE EDIT
const searchModelsDtoSchema = z.object({
  prompt: z.string().min(3),
  strategy: z.enum(['and', 'or']).optional(),
  nbResults: z.number().optional(),
  page: z.number().optional(),
});
export class SearchModelsDto extends createZodDto(searchModelsDtoSchema) {}

const localizedModelDataSchema = z.object({
  name: z.string().optional(),
  shortDescription: z.string().optional(),
  description: z.string().optional(),
  manufacturerUrl: z.string().optional(),
});

const localizedDataSchema = z
  .object({
    en: localizedModelDataSchema.optional(),
    fr: localizedModelDataSchema.optional(),
    es: localizedModelDataSchema.optional(),
    it: localizedModelDataSchema.optional(),
    de: localizedModelDataSchema.optional(),
  })
  .optional();

// Owner orgs can only set PRIVATE/DISTRIBUTOR. PUBLIC promotion is admin-only.
const ownerVisibilitySchema = z.enum(['PRIVATE', 'DISTRIBUTOR']).optional();

const validateModelPeriods = (
  value: {
    inspectionPeriod?: number | null;
    manufactureLifeSpan?: number | null;
    commissioningLifeSpan?: number | null;
  },
  context: z.RefinementCtx,
) => {
  if (!value.inspectionPeriod) {
    return;
  }

  const lifespanChecks = [
    {
      path: 'manufactureLifeSpan' as const,
      value: value.manufactureLifeSpan,
    },
    {
      path: 'commissioningLifeSpan' as const,
      value: value.commissioningLifeSpan,
    },
  ];

  for (const lifespan of lifespanChecks) {
    if (lifespan.value !== null && lifespan.value !== undefined) {
      if (lifespan.value <= value.inspectionPeriod) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          path: [lifespan.path],
          message:
            'Lifespan must be greater than the inspection period when both are defined',
        });
      }
    }
  }
};

const modelDtoSchema = z.object({
  name: z.string().min(1),
  // Brand is optional: a model can exist without an attached brand.
  brandId: z.number().int().positive().nullable().optional(),
  categoryId: z.number().int().positive().nullable().optional(),
  manufacturerId: z.string().nullable().optional(),
  partNumbers: z.array(z.string()).optional(),
  purchasePrice: z.number().int().nonnegative().nullable().optional(),
  inspectionPeriod: z.number().int().nullable().optional(),
  manufactureLifeSpan: z.number().int().nullable().optional(),
  commissioningLifeSpan: z.number().int().nullable().optional(),
  localizedData: localizedDataSchema,
  visibility: ownerVisibilitySchema,
  imagesIds: z.array(z.number().int().positive()).optional(),
  filesIds: z.array(z.number().int().positive()).optional(),
});

const createModelDtoSchema = modelDtoSchema.superRefine(validateModelPeriods);
export class CreateModelDto extends createZodDto(createModelDtoSchema) {}

// brandId stays editable on update, unlike before, so the brand can be changed
// or cleared after creation.
const updateModelDtoSchema = modelDtoSchema
  .partial()
  .superRefine(validateModelPeriods);
export class UpdateModelDto extends createZodDto(updateModelDtoSchema) {}
